// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/browser';

if (
    process.env.NODE_ENV === 'production' &&
    process.env.NEXT_PUBLIC_SENTRY_DSN !== ''
) {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

        // Adjust this value in production, or use tracesSampler for greater control
        tracesSampleRate: 0.1,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: false,

        replaysOnErrorSampleRate: 1.0,

        replaysSessionSampleRate: 0.01,

        integrations: [
            Sentry.browserSessionIntegration(),
            Sentry.replayIntegration({
                // Additional Replay configuration goes in here, for example:
                // maskAllText: true,
                blockAllMedia: true,
            }),
            Sentry.feedbackIntegration({
                themeLight: {
                    accentBackground: 'rgba(13, 88, 139, 1)',
                },
                autoInject: false,
                colorScheme: 'light',
                showBranding: false,
                formTitle: 'Leave us a message',
                submitButtonLabel: 'Send message',
                messagePlaceholder:
                    'Found a bug or have something on your mind? Share it here.',
                successMessageText: 'Thank you for reaching out!',
                messageLabel: 'Message',
            }),
        ],

        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    });
}
